<template>
  <div class="jump">
    <slot></slot>
  </div>
</template>

<script>
import jump from 'jump.js'

export default {
  props: {
    target: String,
    options: {
      type: Object,
      default: () => ({})
    }
  },

  render () {
    this.$el = this.$el.nextSibling
  },

  mounted () {
    this.$el.addEventListener('click', this.handler)
  },

  methods: {
    handler () {
      jump(this.target, this.options)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Jump.vue?2cbcc89e